// extracted by mini-css-extract-plugin
module.exports = {"Catalog":"_77QkZ","Catalog__ControlsBlock":"BuiQz","Catalog__Cards":"FEGeP","Catalog__WrapButton":"dhrQs","Catalog__EmptyMessage":"v1UOW"};